export const isNumeric = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

const isDateTimeEmpty = function (timeString) {
    return !timeString;
};

export const formatTimeString = function (timeString) {
    if (isDateTimeEmpty(timeString)) {
        return '';
    }

    // "2019-01-18T18:30:15.236"
    let parts = timeString.split('T');
    if (parts.length !== 2) {
        return '-';
    }

    let hms = parts[1];
    if (hms.split('.').length === 2) {
        hms = hms.split('.')[0];
    }

    return `${hms}`;
};

export const formatDateTimeString = function (timeString) {
    if (isDateTimeEmpty(timeString)) {
        return '';
    }

    // "2019-01-18T18:30:15.236"
    let parts = timeString.split('T');
    if (parts.length !== 2) {
        return '-';
    }

    let ymd = parts[0];
    let hms = parts[1];
    if (hms.split('.').length === 2) {
        hms = hms.split('.')[0];
    }

    return `${ymd} ${hms}`;

    // if (isDateTimeEmpty(timeString)) {
    //     return '';
    // }

    // let dateObj = new Date(timeString);

    // let month = '' + (dateObj.getMonth() + 1);
    // let day = '' + dateObj.getDate();
    // let year = '' + dateObj.getFullYear();

    // let hours = '' + dateObj.getHours();
    // let minutes = '' + dateObj.getMinutes();
    // let seconds = '' + dateObj.getSeconds();

    // if (month.length < 2) month = '0' + month;
    // if (day.length < 2) day = '0' + day;
    // if (hours.length < 2) hours = '0' + hours;
    // if (minutes.length < 2) minutes = '0' + minutes;
    // if (seconds.length < 2) seconds = '0' + seconds;

    // return [year, month, day].join('-') + ' ' + [hours, minutes, seconds].join(':');
};

export const formatDateString = function (timeString) {
    if (isDateTimeEmpty(timeString)) {
        return '';
    }

    // "2019-01-18T18:30:15.236"
    let parts = timeString.split('T');
    if (parts.length !== 2) {
        return '-';
    }

    let ymd = parts[0];
    let hms = parts[1];
    if (hms.split('.').length === 2) {
        hms = hms.split('.')[0];
    }

    return `${ymd}`;

    // let dateObj = new Date(timeString);

    // let month = '' + (dateObj.getMonth() + 1);
    // let day = '' + dateObj.getDate();
    // let year = '' + dateObj.getFullYear();

    // if (month.length < 2) month = '0' + month;
    // if (day.length < 2) day = '0' + day;

    // return [year, month, day].join('-');
};

export const getTodayDateString = function () {
    let now = new Date();
    let month = '' + (now.getMonth() + 1);
    let day = '' + now.getDate();
    let year = '' + now.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
};

export const getNextYearTodayDateString = function () {
    let now = new Date();
    let month = '' + (now.getMonth() + 1);
    let day = '' + now.getDate();
    let year = now.getFullYear() + 1;
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
};

export const getThisMonthStart = function () {
    let now = new Date();
    let month = '' + (now.getMonth() + 1);
    let day = '01';
    let year = '' + now.getFullYear();
    if (month.length < 2) month = '0' + month;
    return [year, month, day].join('-');
};

export const getThisMonthEnd = function () {
    let temp = new Date(this.getThisMonthStart());
    temp = temp.setMonth(temp.getMonth() + 1); //加一个月
    temp = new Date(temp);
    temp = temp.setDate(temp.getDate() - 1); //减一天
    temp = new Date(temp);
    let month = '' + (temp.getMonth() + 1);
    let day = '' + temp.getDate();
    let year = '' + temp.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
};

export const cutTooLengthString = function (str) {
    return str.length > 15 ? str.substring(0, 15) + '...' : str;
};

export const uuid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

export const repeater = function (str, n) {
    return Array(n).fill(str).join('');
};

/**
 * 数字转千分位字符串
 * @param {*} num 数字
 * @param {*} fractional 小数位数
 * @param {*} currencyPrefix 货币前缀
 */
export const number2ThousandsFormat = function (num, fractional, currencyPrefix) {
    //判断是否有小数点
    if (!num && num !== 0) {
        return '';
    }
    let s = num.toString().indexOf(".");
    if (s === -1) { //是整数
        //return currencyPrefix + (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + repeater('0', fractional);
        return currencyPrefix + (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + (fractional > 0 ? "." + "0".repeat(fractional) : "");
    }
    else { //是小数
        let arr = num.toString().split(".");
        if (arr.length > 1 && arr[1].length < fractional) {
            const decimalPart = (arr[1] + "0".repeat(fractional)).substr(0, fractional);
            //return currencyPrefix + (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + arr[1] + "0";
            return currencyPrefix + (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + (fractional > 0 ? "." + decimalPart : "");
        }
        else {
            const decimalPart = arr[1].substr(0, fractional);
            //return currencyPrefix + (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + arr[1].substr(0, fractional);
            return currencyPrefix + (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + (fractional > 0 ? "." + decimalPart : "");
        }
    }
};
/**
 * 数字转字符串
 * @param {*} num 数字
 * @param {*} fractional 小数位数
 */
export const number2DecimalFormat = function (num, fractional) {
    if (!num && num !== 0) {
        return '';
    }
    let s = num.toString().indexOf(".");
    if (s === -1) { // 是整数
        return (num || 0).toString() + (fractional > 0 ? "." + "0".repeat(fractional) : "");
    }
    else { // 是小数
        let arr = num.toString().split(".");
        if (arr.length > 1 && arr[1].length < fractional) {
            const decimalPart = (arr[1] + "0".repeat(fractional)).substr(0, fractional);
            return (arr[0] || 0).toString() + (fractional > 0 ? "." + decimalPart : "");
        }
        else {
            const decimalPart = arr[1].substr(0, fractional);
            return (arr[0] || 0).toString() + (fractional > 0 ? "." + decimalPart : "");
        }
    }
};
/**
 * 数字保留固定位数小数（采用 toFixed 方法）
 * @param {*} number
 * @param {*} fractional
 */
export const numberToFixed = function (number, fractional) {
    return parseFloat(parseFloat(number).toFixed(fractional));
};

/**
 * 千分位字符串转数字
 * @param {*} str 字符串
 * @param {*} currencyPrefix 货币前缀
 */
export const thousandsFormat2Number = function (str, currencyPrefix) {
    str += '';
    str = str.replace(/[,]/g, '').replace(currencyPrefix, '');
    if (isNumeric(str)) {
        return parseFloat(str);
    }
    return NaN;
};

/**
 * 数字转百分比格式
 * @param {*} num 值域从[0-100]的数字
 */
export const number2PercentFormat = function (num) {
    return num + '%';
};

/**
 * 百分比格式转数字，返回[0-100]的数字
 * @param {*} str
 */
export const percentFormat2Number = function (str) {
    str = str.replace('%', '');
    if (isNumeric(str)) {
        return parseFloat(str);
    }
    return NaN;
};

/**
 * 数组去重
 * @param {*} array
 */
export const arrayUnique = function (array) {
    let res = [];
    for (let i = 0, len = array.length; i < len; i++) {
        let current = array[i];
        if (res.indexOf(current) === -1) {
            res.push(current);
        }
    }
    return res;
};


export const formatDateRange = function (dateA) {
    let a = dateA[0];
    if (a.toString().indexOf('T') === -1) return dateA; //已格式化
    let aJson = new Date(a).toJSON();
    let aNewDate = new Date(+new Date(aJson) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');

    let b = dateA[1];
    let bJson = new Date(b).toJSON();
    let bNewDate = new Date(+new Date(bJson) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');

    dateA[0] = aNewDate;
    dateA[1] = bNewDate;

    return dateA;
};

export const addSumData = function (dataArray, labelField, sumFields, fractional = 2) {
    let sumData = {};
    sumData[labelField] = '合计';
    sumData['action'] = -1;
    sumFields.forEach(f => {
        sumData[f] = 0;
    });
    dataArray.forEach(d => {
        sumFields.forEach(f => {
            sumData[f] += d[f];
        });
    });
    sumFields.forEach(f => {
        sumData[f] = numberToFixed(sumData[f], fractional);
    });
    return sumData;
};

/**
 * 获取当天所在的年度周次
 * @returns {number}
 */
export const getWeek = function () {
    // const d1 = new Date();
    // const d2 = new Date();
    // d2.setMonth(0);
    // d2.setDate(1);
    // const rq = d1 - d2;
    // const s1 = Math.ceil(rq / (24 * 60 * 60 * 1000));
    // return Math.ceil(s1 / 7);
    let now = new Date();
    let beginDate = new Date(now.getFullYear(), 0, 1);
    return Math.ceil((parseInt((now - beginDate) / (24 * 60 * 60 * 1000)) + beginDate.getDay()) / 7);
};
// 通用浮点数计算方法
export const calculate = function (a, b, operator) {
    // eslint-disable-next-line no-use-before-define
    const factor = Math.pow(10, Math.max(decimalLength(a), decimalLength(b)));
    // eslint-disable-next-line no-use-before-define
    const intA = toInteger(a, factor);
    // eslint-disable-next-line no-use-before-define
    const intB = toInteger(b, factor);
  
    let result;
    switch (operator) {
        case '+': // 加法
            result = (intA + intB) / factor;
            break;
        case '-': // 减法
            result = (intA - intB) / factor;
            break;
        case '*': // 乘法
            result = (intA * intB) / (factor * factor);
            break;
        case '/': // 除法
            if (b === 0) {
                throw new Error("Division by zero is not allowed.");
            }
            result = intA / intB;
            break;
        default:
            throw new Error(`Unsupported operator: ${operator}`);
    }
    return result;
};

function decimalLength(number) {
    // 将数字转换为字符串
    const numStr = number.toString();

    // 如果数字是0或者没有小数点，返回0
    if (numStr === "0" || numStr.indexOf('.') === -1) {
        return 0;
    }

    // 计算小数点后的位数
    return numStr.split('.')[1].length;
}
  
// 辅助函数 toInteger，用于将浮点数转换为整数，同时考虑小数位数
function toInteger(number, factor) {
    // 将浮点数乘以因子，然后四舍五入到最接近的整数
    return Math.round(number * factor);
}